import { formatInr, usePricingCatalog } from "../lib/usePricingCatalog";

export const FreeTrialText = () => {
  const catalog = usePricingCatalog();
  const free = catalog?.plans.find((p) => p.allowance_type === "one_time");
  return <>{free ? `${free.minutes} minutes free — one time for new users` : "One-time free trial for new users"}</>;
};

export const ReferralRewardText = () => {
  const catalog = usePricingCatalog();
  return <>{catalog
    ? `Refer ${catalog.referrals_per_reward} friends and earn ${catalog.referral_discount_percent}% off your eligible purchase`
    : "Refer friends and earn a discount on your eligible purchase"}</>;
};

export const PlanSummary = () => {
  const catalog = usePricingCatalog();
  return <>{catalog ? catalog.plans.map((p) =>
    `${p.name}: ₹${formatInr(p.amount_inr)} for ${p.minutes} minutes${p.allowance_type === "one_time" ? " once for new users" : `, valid for ${p.duration_days} days`}`
  ).join(". ") : "See the pricing page for current INR prices and included minutes."} No automatic renewal.</>;
};
